<div class="page">
  <div class="main">
    <app-company-columns [items]="columnConfig" [(value)]="columns"></app-company-columns>
    <app-systems-data-table [columns]="columns"></app-systems-data-table>
  </div>
  <div class="widgets"></div>
</div>
